import { render } from "./OfferSellerInfo.vue?vue&type=template&id=c2130a32&scoped=true"
import script from "./OfferSellerInfo.vue?vue&type=script&lang=js"
export * from "./OfferSellerInfo.vue?vue&type=script&lang=js"

import "./OfferSellerInfo.vue?vue&type=style&index=0&id=c2130a32&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2130a32"],['__file',"webpack-assets/vue/templates/product/catalog/parts/OfferSellerInfo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c2130a32"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c2130a32', __exports__)) {
    api.reload('c2130a32', __exports__)
  }
  
  module.hot.accept("./OfferSellerInfo.vue?vue&type=template&id=c2130a32&scoped=true", () => {
    api.rerender('c2130a32', render)
  })

}


export default __exports__